<template>
  <div>
    <h5 class="headline">{{ $t('contract.product_and_area.headline') }}</h5>
    <p>{{ $t('contract.product_and_area.paragraph_one', {exclusiveType: exclusiveRightType}) }}</p>
    <strong>{{ $t('contract.product_and_area.paragraph_one_one') }}</strong>
    <transition name="highlight">
      <ul>
        <li class="user-output" v-for="product in products" :key="product.id">{{ product.text }}</li>
      </ul>
    </transition>
    <strong>{{ $t('contract.product_and_area.paragraph_one_two') }}</strong>
    <transition name="highlight">
      <ul>
        <li class="user-output">{{ areas }}</li>
      </ul>
    </transition>
    <p>{{ $t('contract.product_and_area.paragraph_two') }}</p>
    <p>{{ $t('contract.product_and_area.paragraph_three', {exclusiveType: exclusiveRightType}) }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    products() {
      return this.$store.state.contract.productsAndArea.products;
    },
    areas() {
      return this.$store.state.contract.productsAndArea.areas;
    },
    exclusiveRightType() {
      let isExclusive = this.$store.state.contract.productsAndArea
        .hasExclusiveRight;
      return isExclusive
        ? this.$t("contract.product_and_area.exclusive")
        : this.$t("contract.product_and_area.non_exclusive");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/ProductAndAreaOutput.vue